import _tableSortingHandler from '@/components/Commons/_mixins/_tableSortingHandler'
export default {
  mixins: [_tableSortingHandler],
  methods: {
    sortByField (fieldName) {
      this.$store.dispatch('UsersStore/sortUsersByField', { fieldName })
    },
    /* Customers */
    sortCustomersByField (fieldName) {
      this.$store.dispatch('UsersStore/sortCustomersByField', { fieldName })
    },
    isSortedByCustomerField (field) {
      const fields = Array.isArray(field) ? field : [field]
      const currentFiltersKeys = Object.keys(this.currentCustomerFilters)
      let isSortedBy = true
      fields.forEach(el => {
        if (!currentFiltersKeys.includes(`order[${el}]`)) isSortedBy = false
      })
      return isSortedBy
    },
    sortCustomerDirection (field) {
      if (!this.isSortedByCustomerField(field)) return false
      return this.currentCustomerFilters[`order[${field}]`]
    }

  },
  computed: {
    currentFilters () {
      return this.$store.getters['UsersStore/filters']
    },
    currentCustomerFilters () {
      return this.$store.getters['UsersStore/customerFilters']
    }
  }
}
